<template lang="pug" @touchmove="(e) => e.preventDefault()">
.buy-card-modal(v-if="show"  @touchmove="(e) => e.preventDefault()")
  .nba-modal-block()
    .header
      .text 购买联名会员
      .close(@click="closeModal")
    .middle(:style="`background-image:url(${info.detailImgUrl})`")
    .bottom
      vipButtonLadder(
        ref="buttonNew",
        :info="info",
        :readSign="false"
        :isNba="true"
        @open="bayCardHandler",
        @openDialog="openDialog",
        @transTab="getTransTab",
        @isNoReadSign="openRead"
        :time="info.time"
        :unOpenShowCanBuy="true"
        :isIndex="isIndex"
        :giftList="[]"
        :propVersion="propVersion"
      )
  .shadow(@click="closeModal"  @touchmove="(e) => e.preventDefault()")
</template>
<script>
import {
  getNoScroll,
} from '@/utils';
// import { CardService } from '@/service/card';
// import eventBus from '@/const/eventBus.js';
// import Toast from '@/components/toast';
// import { Navigator } from '@hb/h5-navigator';
// import { UBT } from '@hb/tianqi/lib/ubt.h5';
import vipButtonLadder from '../vip-button-ladder.vue';
import TransTab from '../transTab.vue';

export default {
  components: {
    TransTab,
    vipButtonLadder,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    info: {
      type: Object,
      default: null,
    },
    readSign: {
      type: Boolean,
      default: false,
    },
    isIndex: {
      type: Boolean,
      default: true,
    },
    unOpenShowCanBuy: {
      type: Boolean,
      required: true,
    },
    giftList: {
      type: Array,
      default: () => [],
    },
    propVersion: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      signInfoDTO: {

      },
      continuousMounth: {},
      oneMounth: {},
      haveContinuousMounth: null,
      isOne: true, // 单月
      params: {},
      tabCode: null,
      wordList: [],
      buyObj: {},
      showName: '',
    };
  },
  watch: {

    show: {
      handler(val) {

      },
      immediate: true,
    },
  },
  mounted() {

  },
  methods: {
    closeModal() {
      getNoScroll(false);
      this.$emit('update:show', false);
    },
    bayCardHandler(val, num, money, payChannel = '', planId = '') {
      this.$emit('open', val, num, money, payChannel, planId, true);
    },
    openDialog() {
      this.$emit('openDialog');
    },
    getTransTab(type, price) {
      this.$emit('transTab', type, price);
    },
    openRead(payChannel = '', planId = '', isNba = false) {
      this.$emit('isNoReadSign', payChannel, planId, isNba);
    },
  },
};
</script>
<style lang="less" scoped>
.buy-card-modal {
  .nba-modal-block {
    position: fixed;
    bottom: 0;
    z-index: 223;
    height: 4.48rem;
    width: 100%;
    background: #fff;
    border-radius: 0.12rem 0.12rem 0 0;

    .header {
      position: relative;
      width: 100%;
      background: url(https://m.hellobike.com/resource/gallery/350/vcY6QVte_nba-header-bg.png);
      background-repeat: no-repeat;
      background-size: 100%;
      height: 0.76rem;
      padding: 0.2rem 0 0 0.23rem;

      .text {
        font-family: PingFang SC, sans-serif;
        font-weight: 600;
        font-size: 0.2rem;
        color: #000;
      }

      .close {
        width: 0.22rem;
        height: 0.22rem;
        background: url(https://m.hellobike.com/resource/gallery/350/mIJubuMB_close.png);
        background-repeat: no-repeat;
        background-size: 100%;
        position: absolute;
        top: 0.08rem;
        right: 0.06rem;
      }
    }

    .middle {
      width: 3.38rem;
      height: 1.74rem;
      background: url(https://m.hellobike.com/resource/gallery/350/3y1zDwXW_nba-card-bg.png);
      background-repeat: no-repeat;
      background-size: 100%;
      margin: 0.04rem auto 0;
    }

    .bottom {
      width: 100%;
      height: 1.69rem;
      // background: url(https://m.hellobike.com/resource/gallery/350/1ZyVLGY4_nba-buy-bg.png);
      // background-repeat: no-repeat;
      // background-size: 100%;
    }
  }

  .shadow {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: #000;
    opacity: 0.7;
    z-index: 222;
  }
}
</style>
